__turbopack_context__.v({
  "className": "plus_jakarta_sans_c758a2e8-module__v28zaG__className",
  "variable": "plus_jakarta_sans_c758a2e8-module__v28zaG__variable",
});
